import EncoderAPI from "@/src/api/EncoderAPI";
import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type { GetEncodingPlanResponse } from "@/src/api/EncoderAPI.types";
import type {
  BandwidthStat,
  GetBandwidthResponse,
} from "@/src/api/StatsAPI.types";
import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

// Keeps the previous period's data while the next one loads.
export function bandwidthQuery({
  startDate,
  endDate,
}: AnalyticsPeriod): Query<GetBandwidthResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getBandwidth,
    params: [{ startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function currentMonthBandwidthQuery(): Query<BandwidthStat[]> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getCurrentMonthBandwidth,
    params: [],
  });
}

export function encodingPlanQuery(): Query<GetEncodingPlanResponse> {
  return EncoderAPI.generateQuery({
    fn: EncoderAPI.getEncodingPlan,
    params: [],
  });
}
